export enum PageWrapperMode {
  DEFAULT = "default",
  FLEX = "flex"
}